import type { ReactElement } from 'react';
import type { Components } from '@amplience/content-types/typings/c-materials-and-care';
import { CommercetoolsProductType } from '@storefront/lib-global/codegen/types';
import { createPDPAmplienceComponent } from '../pdpAmplienceComponents.utils';
import { ProductCareTable } from './ProductCareTable';

interface MaterialsContentProps {
  components: Components;
  type: CommercetoolsProductType;
}

export function MaterialsContent({ components, type }: MaterialsContentProps) {
  if (!components) return null;

  const AmplienceComponents = {
    ...createPDPAmplienceComponent(components),
  };
  return (
    <>
      {components.map((comp, j) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const Component: (props: any) => ReactElement | null = AmplienceComponents[comp._meta.schema];
        const isProductTable: boolean = comp.contentType === 'https://clarks.com/content/c-product-care-table.json';
        const isProductShoe: boolean = type === CommercetoolsProductType.SHOE;

        if (isProductTable && isProductShoe) {
          return <ProductCareTable {...comp} />;
        }

        return Component && <Component {...comp} key={`${comp._meta.schema}-${j}`} />;
      })}
    </>
  );
}
